import { useListReportsByEnterpriseQuery } from '@/graphql/generated';

export const useListReportsByEnterprise = (
  enterpriseId: string | undefined,
) => {
  const { data, loading } = useListReportsByEnterpriseQuery({
    variables: { enterpriseId: enterpriseId ? enterpriseId : '' },
    skip: !enterpriseId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    loading,
    reports: data?.reports,
  };
};
